export default "__VITE_ASSET__CJm8l42l__"